export default __webpack_public_path__ + "static/media/st-hild-logo.07d9474c.png";